export const MARKETING_EMAIL = 'partner-support@getAKKO.com'
